<template>
  <div
    class="form__input"
    :class="{'form__input--error': !!error }"
  >
    <label
      v-if="label"
      :for="id"
      class="form__label"
    >
      {{ label }}
    </label>

    <select
      :id="id"
      :value="value"
      :disabled="disabled"
      :class="{ 'input': true, 'input__error': !!error, 'has-input': value !== '' }"
      :name="name"
      :required="required"
      :placeholder="placeholder"
      @change="changeValue"
      @blur="$emit('blur')"
    >
      <option
        v-if="placeholder !== null"
        value=""
        :disabled="!placeholderEnabled"
      >
        {{ placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="option[keyField]"
        :value="option[keyField]"
        :selected="option[keyField] === value"
      >
        {{ option[displayField] }}
      </option>
    </select>

    <p
      v-show="error && !hideErrorLabel"
      class="form__error"
    >
      {{ error }}
    </p>

    <font-awesome-icon
      :icon="['fas', 'sort']"
      class="icon alt"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.value;
    },
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    keyField: {
      type: String,
      default: 'id',
    },
    displayField: {
      type: String,
      default: 'display_label',
    },
    options: {
      type: Array, // [{id,display_label}]
      required: true,
    },
    label: {
      type: String,
      default: 'Form Label',
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'form-name',
    },
    id: {
      type: String,
      default: 'form-id',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholderEnabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
      required: false,
    },
    onChange: {
      type: Function,
    },
    hideErrorLabel: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
    changeValue(e) {
      this.$emit('change', e.target.value);
      this.$emit('input', e.target.value);

      if (this.onChange) {
        this.onChange();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  position: absolute;
  bottom: 30px;
  right: 15px;
  font-size: 13px;
  color: #e8e9eb;
  pointer-events: none;
}
</style>
